import {CommentsDialog, Side} from '@/components/CommentsDialog';
import SigninConditionalRenderer from '@/components/SigninConditionalRenderer';
import {CaseAddReactionForm} from '@/components/forms/AddReactionForm';
import {trainingPlanResourceComplete} from '@/util/trainingplan';
import {CaseCommentsList} from '@/components/CommentsList';
import React from 'react';


type CommentsDrawerProps = {
    triggerElement?: React.ReactNode;
    caseId: string;
    reloadTrainingPlanById: (id: string | undefined) => void;
    trainingPlan?: {
        id: string;

        resources: {
            resource_id: string;
            completed: boolean;
        }[];
    };
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    blurComments?: boolean;
}

export const CommentsDrawer = ({
    triggerElement,
    caseId,
    open,
    onOpenChange,
    reloadTrainingPlanById,
    trainingPlan,
    blurComments,
}: CommentsDrawerProps) => {
    return (
        <CommentsDialog
            side={Side.Right}
            open={false}
            onOpenChange={onOpenChange}
            triggerElement={triggerElement}
        >
            <SigninConditionalRenderer
                title="You must be logged in to add comments"
                buttonText="Log in to continue"
            >
                <CaseAddReactionForm
                    caseId={caseId}
                    afterCommentSubmitted={() => {
                        reloadTrainingPlanById(trainingPlan?.id);
                    }}
                />
            </SigninConditionalRenderer>
            <CaseCommentsList caseId={caseId} blurComments={blurComments}/>
        </CommentsDialog>
    )
}
